var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "home-a",
    d: "M9.3,21.8 L5.7,21.8 C4.20883118,21.8 3,20.5911688 3,19.1 L3,9.2 C3,8.92226861 3.12822556,8.66009358 3.34745345,8.489583 L11.4474534,2.189583 C11.7724529,1.93680567 12.2275471,1.93680567 12.5525466,2.189583 L20.6525466,8.489583 C20.8717744,8.66009358 21,8.92226861 21,9.2 L21,19.1 C21,20.5911688 19.7911688,21.8 18.3,21.8 L14.7,21.8 L14.7,21.8 L9.3,21.8 L9.3,21.8 Z M12,4.04017543 L4.8,9.64017543 L4.8,19.1 C4.8,19.5970563 5.20294373,20 5.7,20 L8.399,20 L8.4,11.9 C8.4,11.4411788 8.74333667,11.0625482 9.18710591,11.0070123 L9.3,11 L14.7,11 C15.1970563,11 15.6,11.4029437 15.6,11.9 L15.6,11.9 L15.599,20 L18.3,20 C18.7970563,20 19.2,19.5970563 19.2,19.1 L19.2,9.64017543 L12,4.04017543 Z M13.8,12.8 L10.2,12.8 L10.199,20 L13.799,20 L13.8,12.8 Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "home-b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#home-a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "currentcolor",
    fillRule: "nonzero",
    xlinkHref: "#home-a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "currentcolor",
    mask: "url(#home-b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.7c62489762bcf6237c1a435702a28e76.svg";
export { ForwardRef as ReactComponent };